import {
  BGT_ADDRESS,
  GAUGE_1B_ADDRESS,
  GAUGE_20M_ADDRESS,
  GAUGE_100M_ADDRESS,
  GAUGE_330M_ADDRESS,
  GAUGE_420M_ADDRESS,
  GAUGE_690M_ADDRESS,
  HENLO_ADDRESS,
  HONEY_ADDRESS,
  OBERO_ADDRESS,
} from "@/constants/contracts";

export type TokenMeta = {
  key: string; // unique id for UI keys
  type: "native" | "token" | "gauge";
  symbol: string; // display symbol
  unit?: string; // e.g. HENLOCKED for gauges
  address?: `0x${string}` | null; // null for native
  icon: string; // path under /public
  label?: string; // optional longer display label
};

export const BASE_TOKENS: TokenMeta[] = [
  {
    key: "BERA",
    type: "native",
    symbol: "BERA",
    unit: "BERA",
    address: null,
    icon: "/token/bera.png",
  },
  {
    key: "HENLO",
    type: "token",
    symbol: "HENLO",
    unit: "HENLO",
    address: HENLO_ADDRESS as `0x${string}`,
    icon: "/token/henlo.webp",
  },
  {
    key: "BGT",
    type: "token",
    symbol: "BGT",
    unit: "BGT",
    address: BGT_ADDRESS as `0x${string}`,
    icon: "/token/bgt.png",
  },
  {
    key: "HONEY",
    type: "token",
    symbol: "HONEY",
    unit: "HONEY",
    address: HONEY_ADDRESS as `0x${string}`,
    icon: "/token/honey.png",
  },
  {
    key: "OBERO",
    type: "token",
    symbol: "OBERO",
    unit: "OBERO",
    address: OBERO_ADDRESS as `0x${string}`,
    icon: "/token/obero.png",
  },
];

export const GAUGE_TOKENS: TokenMeta[] = [
  {
    key: "HENLOCKED20M",
    type: "gauge",
    symbol: "HENLOCKED20M",
    unit: "HENLOCKED",
    address: GAUGE_20M_ADDRESS as `0x${string}`,
    icon: "/token/20m.PNG",
    label: "Gauge 20M",
  },
  {
    key: "HENLOCKED100M",
    type: "gauge",
    symbol: "HENLOCKED100M",
    unit: "HENLOCKED",
    address: GAUGE_100M_ADDRESS as `0x${string}`,
    icon: "/token/100m.PNG",
    label: "Gauge 100M",
  },
  {
    key: "HENLOCKED330M",
    type: "gauge",
    symbol: "HENLOCKED330M",
    unit: "HENLOCKED",
    address: GAUGE_330M_ADDRESS as `0x${string}`,
    icon: "/token/330m.PNG",
    label: "Gauge 330M",
  },
  {
    key: "HENLOCKED420M",
    type: "gauge",
    symbol: "HENLOCKED420M",
    unit: "HENLOCKED",
    address: GAUGE_420M_ADDRESS as `0x${string}`,
    icon: "/token/420m.png",
    label: "Gauge 420M",
  },
  {
    key: "HENLOCKED690M",
    type: "gauge",
    symbol: "HENLOCKED690M",
    unit: "HENLOCKED",
    address: GAUGE_690M_ADDRESS as `0x${string}`,
    icon: "/token/690m.PNG",
    label: "Gauge 690M",
  },
  {
    key: "HENLOCKED1B",
    type: "gauge",
    symbol: "HENLOCKED1B",
    unit: "HENLOCKED",
    address: GAUGE_1B_ADDRESS as `0x${string}`,
    icon: "/token/1b.PNG",
    label: "Gauge 1B",
  },
];

export const ALL_TOKENS: TokenMeta[] = [...BASE_TOKENS, ...GAUGE_TOKENS];
export const TOKENS: TokenMeta[] = ALL_TOKENS;
